import {Trans} from '@lingui/macro';
import React from 'react';

import {CollapsedItemKeyPrefixesEnum} from '../../../models/api/localPreferencesModel';
import {useSettingsInfoBox, UseSettingsInfoBoxProps} from '../../helpers/settingsInfoBox';

/*
 * Consts.
 */

const settingsInfoBoxProps: UseSettingsInfoBoxProps = {
  settingsExpandedKey: CollapsedItemKeyPrefixesEnum.SETTINGS_LOCAL_APPLICATIONS,
  title: <Trans id="settings-applications-infobox-title">Applications</Trans>,
  body: (
    <Trans id="settings-applications-infobox-body">
      <p>
        You can create <strong>applications</strong> to extend Front.
      </p>
      <p>For example, an application can add new panels, or provide useful previews to specific URLs</p>
    </Trans>
  ),
};

/*
 * Hook.
 */

export function useApplicationsInfoBox() {
  return useSettingsInfoBox(settingsInfoBoxProps);
}
